import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NbAccordionItemComponent } from "@nebular/theme";
import { AudioClient } from "../../../../System-api";
import { languageCode } from "./language-code-llm";

@Component({
  selector: "ngx-llm-configuration",
  templateUrl: "./llm-configuration.component.html",
  styleUrls: ["./llm-configuration.component.scss"],
})
export class LLMConfigurationComponent implements OnInit, OnDestroy {
  @ViewChild("advanced") advancedItem: NbAccordionItemComponent;
  @Input() data: any;
  @Input() language: any;
  @Input() languages: any = languageCode;
  @Input() isAction: any = true;
  @Input() displayModel: any = false;
  @Input() displayKnowledge: any = false;
  @Input() displayLanguage: any = false;
  @Input() displayNotMatch: any = false;
  constructor() {}

  ngOnInit(): void {
    if (
      this.data.temperature &&
      !isNaN(this.data.temperature) &&
      Number(this.data.temperature) > 1
    ) {
      this.data.temperature = 1;
    }
  }
  ngOnDestroy(): void {}

  validateTopK() {
    if (this.data.topK > 10) {
      this.data.topK = 3;
    }
  }

  setTemperature(duration: number) {
    this.data.temperature = duration;
  }

  getTemperature(): number {
    return this.data.temperature * 100;
  }

  setTopP(duration) {
    this.data.topP = duration;
  }

  setNumberOutput(duration) {
    this.data.numberOutput = duration;
  }
  handleMaxValueSimilarityCutoff(data) {
    const inputValue = data?.target?.value?.trim();
    if (inputValue && !isNaN(inputValue)) {
      if (Number(inputValue) < 1) {
        this.data.similarityCutOff = 1;
      } else if (+inputValue > 100) {
        this.data.similarityCutOff = 100;
      }
    }
  }
  chooseModel($event : Event) {
    $event.stopPropagation();
  }
  getNumberOutput(): number {
    return (this.data.numberOutput * 100) / 4000;
  }

  setFrequencyPenalty(duration) {
    this.data.frequencyPenalty = parseFloat(duration);
  }

  getFrequencyPenalty() {
    return (
      ((parseFloat(this.data.frequencyPenalty.toString() || "0") + 2) / 4) * 100
    );
  }
  setSimilarityCutoff(duration) {
    this.data.similarityCutOff = duration;
  }
  getPresencePenalty() {
    return (
      ((parseFloat(this.data.presencePenalty.toString() || "0") + 2) / 4) * 100
    );
  }

  setPresencePenalty(duration) {
    this.data.presencePenalty = duration;
  }

  toggleAdvanced() {
    this.advancedItem.toggle();
  }

  handleMaxValueNumberOutput(data) {
    const inputValue = data?.target?.value?.trim();
    if (inputValue && !isNaN(inputValue)) {
      if (Number(inputValue) > 4000) {
        this.data.numberOutput = 4000;
      }
    } else {
      this.data.numberOutput = 0;
    }
  }

  handleMaxValueTemperature(data) {
    const inputValue = data?.target?.value?.trim();
    if (inputValue && !isNaN(inputValue) && Number(inputValue) > 1) {
      this.data.temperature = 1;
    } else {
      this.data.temperature = 0;
    }
  }

  handleMaxValueTopP(data) {
    const inputValue = data?.target?.value?.trim();
    if (inputValue && !isNaN(inputValue)) {
      if (Number(inputValue) < 0) {
        this.data.topP = 0;
      } else if (+inputValue > 1) {
        this.data.topP = 1;
      }
    } else {
      this.data.topP = 0;
    }
  }

  handleMaxValueFrequencyPenalty(data) {
    const inputValue = data?.target?.value?.trim();
    if (inputValue && !isNaN(inputValue)) {
      if (Number(inputValue) < -2) {
        this.data.frequencyPenalty = -2;
      } else if (+inputValue > 2) {
        this.data.frequencyPenalty = 2;
      }
    } else {
      this.data.frequencyPenalty = 0;
    }
  }

  handleMaxValuePresencePenalty(data) {
    const inputValue = data?.target?.value?.trim();
    if (inputValue && !isNaN(inputValue)) {
      if (Number(inputValue) < -2) {
        this.data.presencePenalty = -2;
      } else if (+inputValue > 2) {
        this.data.presencePenalty = 2;
      }
    } else {
      this.data.presencePenalty = 0;
    }
  }

  blockE(event: KeyboardEvent, blockDot = false, blockMinus = false) {
    if (
      event.key === "Backspace" ||
      event.key === "Tab" ||
      event.key === "Enter" ||
      event.key === "Escape" ||
      (!blockMinus && event.key === "-") ||
      (!blockDot && event.key === ".")
    ) {
      return;
    }

    if (
      event.ctrlKey &&
      (event.key === "a" ||
        event.key === "c" ||
        event.key === "x" ||
        event.key === "v")
    ) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (event.key < "0" || event.key > "9") {
      event.preventDefault();
    }
  }
}
